import Vue from 'vue';
import VueRouter from 'vue-router';
import hostList from '../data/urls.json';
Vue.use(VueRouter);

//console.log(location)
if (location.pathname == "/") {
	hostList.forEach(el => {
		if (el.host == location.host) {
			location.href = el.redirect;
			return;
		}
	});
}

const routes = [
	{
		path: '/:EventUrl/login',
		name: 'Login',
		props: true,
		component: () => import('../views/login.vue')
	},
	{
		path: '/companyupdate',
		name:'updateLayout',
		props: true,
		component: () => import('../views/layoutupdate.vue'),
		children: [
			{
				path: '',
				name: 'CompanyUpdate',
				component: () => import('../views/profile.vue')
			}
		]
	},
	{
		path: '/applink',
		name:'linkAppLayout',
		component: () => import('../views/layoutupdate.vue'),
		children: [
			{
				path: ':LinkId',
				props: true,
				name: 'ShareLink',
				component: () => import('../views/linkBasedApp.vue')
			}
		]
	},
	{
		path: '/app',
		props: true,
		component: () => import('../views/layout.vue'),
		children: [
			{
				path: '',
				name: 'Dashboard',
				component: () => import('../views/dashboard.vue')
			},
			{
				path: 'dashboard',
				name: 'DashboardSelf',
				component: () => import('../views/dashboard.vue')
			},
			{
				path: 'newapplication',
				name: 'Application',
				component: () => import('../views/application.vue')
			},
			{
				path: 'profile',
				name: 'Profile',
				component: () => import('../views/viewprofile.vue')
			},
			{
				path: 'reports',
				name: 'Reports',
				component: () => import('../views/reports.vue')
			},
			{
				path: 'changepassword',
				name: 'ChangePassword',
				component: () => import('../views/ChangePassword.vue')
			}
		]
	},
	{
		path: '*',
		name: 'NoFound',
		component: () => import('../views/notfound.vue')
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router;
